

<div class="d-flex align-items-center gap-2">
  <ngx-spinner [zIndex]="100" name="spProvinciaLocalidad" bdColor="rgba(255,255,255,0.8)" size="default"
    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>
  <app-buscar-provincia-georef [idLocalidad]="idLocalidadActual"
    [provinciaIngreso]="provinciaActual"
    (provinciaSeleccionada)="onProvinciaSeleccionada($event)">
  </app-buscar-provincia-georef>

  <app-buscar-localidad-georef
    [provincia]="provinciaActual"
    [idLocalidad]="idLocalidadActual"
    (localidadSeleccionada)="onLocalidadSeleccionada($event)">
  </app-buscar-localidad-georef>
</div>
